export const insurances = [
    {label: "I don't have it", value: "NONE"},
    {label: "24PetWatch", value: "TWENTY_FOUR_PETWATCH"},
    {label: "AKC Pet Insurance", value: "AKC_PET_INSURANCE"},
    {label: "ASPCA", value: "ASPCA"},
    {label: "Embrace", value: "EMBRACE"},
    {label: "Eusoh", value: "EUSOH"},
    {label: "Figo", value: "FIGO"},
    {label: "GEICO", value: "GEICO"},
    {label: "Hartville", value: "HARTVILLE"},
    {label: "Healthy Paws", value: "HEALTHY_PAWS"},
    {label: "Lemonade", value: "LEMONADE"},
    {label: "Nationwide", value: "NATIONWIDE"},
    {label: "Pet Assure", value: "PET_ASSURE"},
    {label: "PetFirst", value: "PETFIRST"},
    {label: "PetPartners", value: "PETPARTNERS"},
    {label: "Petplan", value: "PETPLAN"},
    {label: "PetPremium", value: "PETPREMIUM"},
    {label: "Pets Best", value: "PETS_BEST"},
    {label: "Pets Plus Us", value: "PETS_PLUS_US"},
    {label: "Petsecure", value: "PETSECURE"},
    {label: "Progressive", value: "PROGRESSIVE"},
    {label: "Prudent Pet", value: "PRUDENT_PET"},
    {label: "Pumpkin", value: "PUMPKIN"},
    {label: "Spot", value: "SPOT"},
    {label: "Trupanion", value: "TRUPANION"},
    {label: "TrustedPals", value: "TRUSTEDPALS"},
    {label: "USAA", value: "USAA"},
    {label: "Other", value: "OTHER"},
]

export const insuranceList = [
    "I don't have it",
    "24PetWatch",
    "AKC Pet Insurance",
    "ASPCA",
    "Embrace",
    "Eusoh",
    "Figo",
    "GEICO",
    "Hartville",
    "Healthy Paws",
    "Lemonade",
    "Nationwide",
    "Pet Assure",
    "PetFirst",
    "PetPartners",
    "Petplan",
    "PetPremium",
    "Pets Best",
    "Pets Plus Us",
    "Petsecure",
    "Progressive",
    "Prudent Pet",
    "Pumpkin",
    "Spot",
    "Trupanion",
    "TrustedPals",
    "USAA",
    "Other",
]